<template>
  <div class="payment-processed">
    <img
      class="error-image"
      v-if="statusCode === '401'"
      src="../../../../assets/unauthorised.png"
      alt=""
    />
    <img
      class="error-image"
      v-if="statusCode === 'networkError'"
      src="../../../../assets/networkError.png"
      alt=""
    />
    <img
      class="error-image"
      v-if="statusCode === '500'"
      src="../../../../assets/unKnownError.png"
      alt=""
    />
    <img
      class="error-image"
      v-if="statusCode === 'other'"
      src="../../../../assets/unKnownError.png"
      alt=""
    />
    
    <span class="success-text mt-3 mb-3"> {{ errorTitle }}</span>
    <span class="payment-text">{{ errorDetail }}</span>
    <!-- <b-button
      @click="nextPage()"
      class="next-button btn-ripple"
      variant="primary"
      >Please Try Again</b-button
    > -->
  </div>
</template>

<script>
export default {
  props: ["errorCode", "errorTitle", "errorDetail"],
  data: function () {
    return {
      statusCode: this.errorCode,
    };
  },
  name: "errors-page", 
};
</script>

<style lang="scss" scoped>
.error-image {
  width: 70px;
  height: auto;
}
.next-button {
  width: 329px;
  height: 48px;
  border-radius: 4px;
  background: var(--warning-color);
  border: none;
  margin: 24px 50px;
}
.next-button:hover {
  background: var(--warning-color);
  color: white;
}
.payment-processed {
  margin: 10% auto;
  max-width: 446px;
  border: none;
  padding: 10px;
  text-align: center;
}

.success-text {
  display: block;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  /* or 133% */

  text-align: center;
  letter-spacing: -0.1px;

  color: #000000;
}

.payment-text {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  /* or 156% */

  text-align: center;

  /* Gray 2 */

  color: #4f4f4f;
}
</style>